/**
 * FUP variable descriptions and examples.
 * Mirrors src/constants/fupVariables.ts from Nurture.
 * Used by FupCreateSessionForm.vue for human-friendly variable labels.
 */

export const FUP_VARIABLE_MAP = {
  nome: { label: 'Nome do cliente', example: 'João Silva' },
  produto: { label: 'Nome do produto', example: 'Plano Premium' },
  empresa: { label: 'Nome da empresa', example: 'Clínica Saúde Total' },
  valor: { label: 'Valor ou preço', example: 'R$ 297,00' },
  data: { label: 'Data', example: '15/04/2026' },
  horario: { label: 'Horário', example: '14h30' },
  link: { label: 'Link', example: 'https://calendly.com/...' },
  telefone: { label: 'Telefone', example: '(67) 99999-9999' },
  email: { label: 'E-mail', example: 'joao@empresa.com' },
};

export function getVarLabel(key) {
  return FUP_VARIABLE_MAP[key]?.label ?? key;
}

export function getVarExample(key) {
  return FUP_VARIABLE_MAP[key]?.example ?? '';
}

export function getVarPlaceholder(key) {
  const info = FUP_VARIABLE_MAP[key];
  if (info) return `${info.label} (ex: ${info.example})`;
  return `Informe o valor para ${key}`;
}
